import axios from 'axios';
import TokenService from "./Token.service";
import Rest from './Rest';
// Base URL of the API  
// const API_BASE_URL = 'https://localhost:7160/api/E_Comm'; 
const API_BASE_URL = process.env.REACT_APP_API_URL;

export class RequestorService {


  static async getRequestorList(pagination) {
    return Rest.post(`${API_BASE_URL}/requestor-listing`, pagination)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching requestor list:', error);
        throw error;
      });
  }

  static async getRequestorTrainingDetails(userId) {
    try {

      return Rest.post(`${API_BASE_URL}/requestor-training`, {
        user_id: userId,
      }
      ).then(response => {
        return response.data;
      })
        .catch(error => {
          console.error('Error fetching requestor training details:', error);
          throw error;
        });
    } catch (error) {
      console.error('Error fetching requestor training details:', error);
      throw error;
    }
  }
  static async updateRequestorTrainingDetails(userId, trainingStatus, trainingDate) {
    try {
      return Rest.post(`${API_BASE_URL}/update-training`, {
        user_id: userId,
        training_status: trainingStatus,
        training_date: trainingDate,
      }).then(response => {
        return response.data;
      })
        .catch(error => {
          console.error('Error fetching requestor training details:', error);
          throw error;
        });

    } catch (error) {
      console.error('Error updating requestor training details:', error);
      throw error;
    }
  }
  static async exportRequestorList(filters) {
    return Rest.post(`${API_BASE_URL}/export-requestor`, { filters })
        .then(response => { 
            return response.data; 
        })
        .catch(error => {
            console.error('Error exporting requestor list:', error);
            throw error;
        });
  } 

  static async addRequestor(requestorDetails) {
    return Rest.post(`${API_BASE_URL}/user/add`, requestorDetails)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error while adding requestor user', error);
        throw error;
      });
  }

  static async updateRequestor(requestorDetails){
    return Rest.post(`${API_BASE_URL}/user/update-requestor`, requestorDetails)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error while updating requestor user', error);
      throw error;
    });
  }
  static async getLabList(){
    return Rest.get(`${API_BASE_URL}/lab/options`)
    .then(response =>{
      return response.data
    })
  };
  
  static async getRequestorDetails(user_id){
    return Rest.post(`${API_BASE_URL}/user/requestor-details`, { user_id });
  };

  static async addParentStudy(payload){
    return Rest.post(`${API_BASE_URL}/add-parent-study`,  payload )
    .then(response =>{
      return response.data
    });
  };

  static async updateParentStudy(payload){
    return Rest.post(`${API_BASE_URL}/update-parent-study`, payload )
    .then(response =>{
      return response.data
    });
  };

  static async getParentStudies(payload){
    return Rest.post(`${API_BASE_URL}/parent-study-list`, payload)   
    .then(response =>{
      return response.data
    });
  };

  static async inactiveDeactiveDeleteParentStudy(payload){
      return Rest.post(`${API_BASE_URL}/update-parent-study-status`, payload)
      .then(response =>{
        return response.data
      });
  };

    static async fetchParentStudyDonors(payload){
      return Rest.post(`${API_BASE_URL}/involved-parent-study-donors`, payload)
      .then(response =>{
        return response.data
      });
  };

}


export function getStatuses() {
  return Promise.resolve(statusTypes);
}
 

// admin [1, 4, 5, 6, 7, 8] requestor  [ 0 , 1, 2 ]
export const statusTypes = [
  { id: 0, label: 'Active', value: 1 },
  { id: 1, label: 'Paused', value: 0 },  
];
